import type { ID } from "../types";

const NUMBER_OF_ACTIVITY_TEMPLATE = 9;
const NUMBER_OF_DIFFICULTY = 6;
const INITIAL_DIFFICULTY_VALUE = 1 / NUMBER_OF_DIFFICULTY;
const INITIAL_TEMPLATE_VALUE = 1 / NUMBER_OF_ACTIVITY_TEMPLATE;

export interface IIndividualModel {
  easy: number;
  medium: number;
  hard: number;
  dropdown: number;
  coterieField: "VERBAL" | "NUMERIC";
  fillInTheBlanks: number;
  grouping: number;
  matching: number;
  mcma: number;
  mcsa: number;
  openEnded: number;
  ordering: number;
  trueFalse: number;
  userId: ID;
}

export const constructBaseVerbalIndvidualModel = (
  userId: ID,
): IIndividualModel => {
  return {
    easy: INITIAL_DIFFICULTY_VALUE,
    medium: INITIAL_DIFFICULTY_VALUE,
    hard: INITIAL_DIFFICULTY_VALUE,
    dropdown: INITIAL_TEMPLATE_VALUE,
    coterieField: "VERBAL",
    fillInTheBlanks: INITIAL_TEMPLATE_VALUE,
    grouping: INITIAL_TEMPLATE_VALUE,
    matching: INITIAL_TEMPLATE_VALUE,
    mcma: INITIAL_TEMPLATE_VALUE,
    mcsa: INITIAL_TEMPLATE_VALUE,
    openEnded: INITIAL_TEMPLATE_VALUE,
    ordering: INITIAL_TEMPLATE_VALUE,
    trueFalse: INITIAL_TEMPLATE_VALUE,
    userId,
  };
};

export const constructBaseNumericIndividualModel = (
  userId: ID,
): IIndividualModel => {
  return {
    easy: INITIAL_DIFFICULTY_VALUE,
    medium: INITIAL_DIFFICULTY_VALUE,
    hard: INITIAL_DIFFICULTY_VALUE,
    dropdown: INITIAL_TEMPLATE_VALUE,
    coterieField: "NUMERIC",
    fillInTheBlanks: INITIAL_TEMPLATE_VALUE,
    grouping: INITIAL_TEMPLATE_VALUE,
    matching: INITIAL_TEMPLATE_VALUE,
    mcma: INITIAL_TEMPLATE_VALUE,
    mcsa: INITIAL_TEMPLATE_VALUE,
    openEnded: INITIAL_TEMPLATE_VALUE,
    ordering: INITIAL_TEMPLATE_VALUE,
    trueFalse: INITIAL_TEMPLATE_VALUE,
    userId,
  };
};
